export let InGameCategoryKey;

(function (InGameCategoryKey) {
  InGameCategoryKey["BattleRewards"] = "battle_rewards";
})(InGameCategoryKey || (InGameCategoryKey = {}));